<template>
  <div id="mallnum">
<!--    <div class="bg-color-black">-->
      <div class="d-flex pt-2 pl-2">
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">交易数量</span>
        </span>
      </div>
      <div style="width: 100%;font-size: 20px;color: #4c9bfd;padding:0.2rem;"><i class="icon-dot" style="color: #ed3f35"></i>交易笔数<span style="font-size: 30px;color: #ffffff;padding: 0 0.1rem">{{allNum}}</span>笔</div>
      <div class="d-flex jc-center" style="clear: both;height: 80%;width: 100%">
        <Echart
            :options="option"
            id="nChart"
            height="100%"
            width="100%"
        ></Echart>
      </div>

    </div>
<!--  </div>-->
</template>

<script>
import Echart from '@/common/echart'
import sciApi from '@/api/index.js'
let Chart
export default {
  data() {
    return {
      tag:'',
      option:{},
      allNum:0,
      allNumList:[],
      Num:{
        '知识产权':0,
        '法律服务':0,
        '政策申报':0,
        '工商财税':0,
        '科技金融':0,
        '检验检测':0,
        '科技咨询':0,
        '设备共享':0,
        '技研中心':0,
      },
    };
  },
  watch:{
    setregion:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val

      },
    },
    tag:{
      immediate: false,
      deep: true,
      handler(val) {
        console.log(val,'val')
        this.init().then(()=>{
          let num=[]
          for (let key in this.Num){
            num.push({ name:key,
              value:this.Num[key]})
          }
          this.option.series[0].data=num.slice(0,9)
          Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
        })
      },
    },
  },
  computed:{
    setregion() {
      return this.$store.state.region
    }
  },
  mounted() {
    this.tag=''
    this.init().then(()=>{
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key]})
      }
      this.option.series[0].data=num.slice(0,9)
      Chart.setOption(JSON.parse(JSON.stringify(this.option)),true);
    })
    this.option = {
      color: [
        "#37a2da",
        "#32c5e9",
        "#9fe6b8",
        "#ffdb5c",
        "#ff9f7f",
        "#fb7293",
        "#e7bcf3",
        "#8378ea"
      ],
      tooltip: {
        trigger: "item",
        formatter: "{b}<br/>交易笔数：{c}笔"
      },
      calculable: true,
      legend: {
        selectedMode:false,
        orient: "vertical",
        right:0,
        bottom:20,
        itemWidth:15,
        textStyle:{
          color: '#fff'
        }
      },
      series: [
        {
          bottom:'5%',
          name: "数据统计",
          type: 'pie',
          // radius: [0, 60],
          roseType: "area",
          center: ["30%", "50%"],
           avoidLabelOverlap: true,
          label: {
              formatter: "{number|{c}}笔\n{b}",
              rich: {
                number: {
                  color: '#fff',
                  fontSize:16
                }
              },
            show: true,
            position: 'top'
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: '24',
          //   }
          // },
          // label:{
          //   show:false,
          //   fontSize:14,
          // },
          // center: ["50%", "60%"],
          data: []
        }
      ]
    }
    this.drawLine();
  },


  components: {
    Echart
  },
  methods: {
    async init(){
      const that = this;
      // await sciApi.selectMall({})
      await sciApi.selectTechnology({level1: "384354211555599100",level2:"384354211555599103", pageSize: 1000, pageNum: 1}).then((data) => {
        // data 就是接口返回值
        this.allNumList = data.list || []
        if(this.tag!==''){
          this.allNumList.forEach((item) => {
            if(item.mapAreaDisplay == that.tag)
            {
              that.Num[item.level3Display] += parseInt(item.mapNum);
            }else {
              that.Num[item.level3Display] = 0;
            }
          })
        }else {
          this.allNumList.forEach((item) => {
            this.allNum += parseInt(item.mapNum)
            that.Num[item.level3Display] += parseInt(item.mapNum);
          })
        }
      })
    },
    drawLine:function (){
      Chart = this.$echarts.init(document.getElementById('nChart'))
      Chart.setOption(JSON.parse(JSON.stringify(this.option)));
      // option && myChart.setOption(option);
    },
  }
};
</script>

<style lang="scss">
#mallnum {

  padding: 0.2rem;
  height:100%;
  width: 100%;
  //border-radius: 0.0625rem;
  .bg-color-black {
    //padding: 0.0625rem;
    //height: auto;
    //border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;
    .active-ring-name {
      padding-top: 0.125rem;
    }
  }

  .bottom-data {
    .item-box {
      float: left;
      position: relative;
      width: 33%;
      color: #d3d6dd;
      // 金币
      .coin {
        position: absolute;
        left: 0.1rem;
        top: 0.2125rem;
        font-size: 0.25rem;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
    }
  }
}
</style>